// ════════════════════════════════════════════════════════════════════════════
// "TypeError: Failed to fetch" — LỜI GỌI SERVER ACTION KHÔNG ĐI TỚI MÁY CHỦ.
//
// 🩸 VÉ THẬT 05/08/2026 — /security/password (bản b1dcb45):
//     TypeError: Failed to fetch
//         at M (…/_next/static/chunks/3200-075461d0cf4aef5e.js:1:50622)
//
// ĐÃ GIẢI MÃ bằng chính bản dựng ở máy (mảnh 3200 TRÙNG BĂM với bản thật) + source map:
//   cột 50622 rơi vào `server-action-reducer.ts:92` của Next — đúng dòng
//       const res = await fetch(url, { method: "POST", headers: {…ACTION_HEADER…}, body })
//   tức khung `M` = `fetchServerAction`, hàm Next dùng để GỌI MỌI SERVER ACTION.
//   ⇒ Không phải lỗi trong mã nghiệp vụ: cú POST tới máy chủ KHÔNG ĐI ĐƯỢC (rớt wifi phòng
//     khám, 3G chập, máy chủ Railway đang khởi động lại, proxy cắt giữa chừng).
//
// 🕳️ VÌ SAO NÓ THÀNH LỖI CHỨ KHÔNG PHẢI MỘT DÒNG CHỮ ĐỎ: `fetch` hỏng thì lời hứa BỊ TỪ CHỐI.
//    Nơi gọi nào `await` server action mà KHÔNG try/catch thì cú từ chối ấy văng thẳng ra —
//    trong `useActionState`, React giữ lại rồi NÉM LẠI lúc vẽ ⇒ error boundary nuốt cả trang.
//    Người đang đổi mật khẩu mất trắng thứ vừa gõ và đọc được đúng một câu tiếng Anh.
//
// ⚠️ TUYỆT ĐỐI KHÔNG tự tải lại trang cho họ lỗi này (khác `lib/loi/lech-phien-ban.ts`): lệch
//    phiên bản thì tải lại là CHỮA, còn rớt mạng thì tải lại chỉ QUĂNG MẤT thứ người ta đang gõ
//    dở mà mạng vẫn chưa về. Ở đây chỉ nói cho họ biết và để họ bấm lại.
//
// THUẦN: không React, không DOM, không fetch → test rà thẳng được.
// ════════════════════════════════════════════════════════════════════════════

/**
 * Sáu cách các trình duyệt nói CÙNG một chuyện: "cú fetch không đi tới nơi".
 * Phải kể đủ vì phòng khám dùng đủ loại máy (Chrome bàn giấy, Safari iPad, Zalo in-app).
 *
 * XUẤT RA NGOÀI vì components/ClientErrorReporter.tsx cũng phải nhận ĐÚNG họ này (bộ lọc "rớt
 * mạng vết TRỤI"). Chép tay bản thứ hai ở đó là đúng cái bẫy đã mắc hồi 12/08: thêm câu ở một
 * nơi, nơi kia vẫn mù, rồi hai bên lệch nhau mà không ai hay.
 */
export const CAU_FETCH_HONG = [
  /Failed to fetch/i, //                              Chrome · Edge · Cốc Cốc
  /NetworkError when attempting to fetch resource/i, //Firefox
  /Load failed/i, //                                  Safari · iOS (WKWebView)
  /The network connection was lost/i, //              Safari khi mạng rớt giữa chừng
  /Network request failed/i, //                       WebView Android cũ
  // 🩸 vé thật 12/08/2026 ở /appointments: WebKit trong-app (Zalo · Facebook trên iOS) nói gọn
  // "network error", vết lỗi TRỤI không một khung nào. Thiếu câu này thì cả họ mất một nhánh.
  /network error/i, //                                WebKit trong-app (Zalo · Facebook iOS)
];

/**
 * Lỗi này có phải "gọi máy chủ không đi được" không?
 *
 * Phải khớp CẢ HAI vế mới nhận — hẹp là CỐ Ý:
 *   ① là `TypeError` — `fetch` LUÔN từ chối bằng `TypeError` khi hỏng ở tầng mạng
 *      (lỗi nghiệp vụ, lỗi máy chủ 500 thì KHÔNG rơi vào đây: 500 vẫn là một đáp trả, fetch nhận
 *      bình thường), VÀ
 *   ② câu lỗi thuộc họ ở trên.
 *
 * Vế ① là thứ giữ cho luật này không bắt oan: "Load failed" đứng một mình là câu quá chung, mã
 * của mình cũng có thể ném ra chữ đó. Bắt oan = báo "mất mạng" cho một bọ thật ⇒ không ai đi tìm.
 * Bắt hụt thì chỉ mất câu chữ CHÍNH XÁC, nơi gọi vẫn có câu dự phòng tiếng Việt — nên luật này
 * cố ý nghiêng về phía bắt hụt.
 */
export function laLoiKhongToiMayChu(err: unknown): boolean {
  if (err == null) return false;
  const ten = (err as { name?: unknown }).name;
  if (ten !== "TypeError") return false; // ①
  const cau = String((err as { message?: unknown }).message ?? "");
  return CAU_FETCH_HONG.some((mau) => mau.test(cau)); // ②
}
